import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Creates a new cashier user by sending a POST request to the backend.
 *
 * @param {Object} cashierData - The data of the cashier to be created.
 * @param {string} cashierData.name - The name of the cashier.
 * @param {string} cashierData.username - The username of the cashier.
 * @param {string} cashierData.password - The password for the cashier.
 * 
 * @returns {Promise<Object>} - The response data from the server after creation.
 * 
 * @throws {Error} - If the request fails or the response is not OK.
 * 
 * @author Susovan
 */
const createCashier = async (cashierData) => {
  //Taking role from the env file
  const role = JSON.parse(process.env.REACT_APP_USER_ROLES_JSON)
  return await apiCall(AUTH_ROUTES.USERS_API_ENDPOINT, {
    method: "POST",
    body: {
      name: cashierData.name,
      email: cashierData.email,
      username: cashierData.username,
      password: cashierData.password,
      role: role.CASHIER,
      active: true,
    },
  });
};

export default createCashier;
